import { getConfig } from './utils/get-config.js';

interface IProps {
  config: ReturnType<typeof getConfig>;
}

const Mountain = ({ config }: IProps) => {
  const { high, mid, sub } = config;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="210" height="163" viewBox="0.5 792.5 210 163">
      <path
        className={`AvalancheAdvisory-indicator ${high.className}`}
        fill="#FFF"
        stroke="#444"
        d="M139.778 822.764l-18.03 33.587 8.159 14.581 32.529-6.584-22.658-41.584zM87.468 792.5l-42.742 79.617 77.021-15.767-34.279-63.85z"
      />
      <path
        className={`AvalancheAdvisory-indicator ${mid.className}`}
        fill="#FFF"
        stroke="#444"
        d="M162.436 864.348l-32.529 6.584 24.837 46.317 32.346-6.974-24.654-45.927zM121.748 856.351l-77.021 15.767-27.73 51.654 131.016-18.497-26.265-48.924z"
      />
      <path
        className={`AvalancheAdvisory-indicator ${sub.className}`}
        fill="#FFF"
        stroke="#444"
        d="M154.743 917.249l19.695 37.251H210.5l-23.411-44.225-32.346 6.974zM16.996 923.771L.5 954.5h173.938l-26.426-49.226-131.016 18.497z"
      />
    </svg>
  );
};

export { Mountain };
